export default "<h3>February 10, 2019</h3>\r\n<p>Update 0.75 fixes some bugs.</p>";